import React from 'react';
import { Link, LinkType } from '@eika/link';

const Personvern = () => (
    <p className="personvern-tekst">
        Etter at vi har kontaktet deg blir informasjonen du oppgir her slettet etter gjeldende rutiner hos oss. Dersom
        du ønsker informasjon om dine rettigheter rundt blant annet sletting, innsyn, klage og samtykke finner du det på
        vår{' '}
        <Link
            href="https://www.eikaforsikring.no/personvern-cookies"
            target="_blank"
            className="personvern-lenke"
            linkType={LinkType.INLINE}
        >
            personvernside
        </Link>
        .
    </p>
);

export default Personvern;
